export class LoadedError extends Error {
  id: string
  code: number
  details: string[]
  status: number

  constructor(
    id: string,
    code: number,
    message: string,
    details: string[] = [],
    status: number
  ) {
    super(message)
    this.name = 'LoadedError'

    this.id = id
    this.code = code
    this.details = details
    this.status = status
  }
}
